import { DomainSerializer } from '../../global/serializables/domain.serializer';
import { AuditoriaAlterarParcela } from '../domain/AuditoriaAlterarParcela.model';

export class AuditoriaAlterarParcelaSerializer extends DomainSerializer<AuditoriaAlterarParcela> {}
